import { InputSizes } from '../../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

type EyeSlashIconProps = {
  size: InputSizes;
};

const EyeSlashIcon = (props: EyeSlashIconProps) => {
  const { size } = props;
  return (
    <svg {...stylex.props(styles.base, styles[size])} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path
        {...stylex.props(styles.base)}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.46964 2.96967C2.76253 2.67678 3.23741 2.67678 3.5303 2.96967L6.33755 5.77692C8.00113 4.80617 9.93652 4.25 11.9999 4.25C17.0968 4.25 21.4001 7.63879 22.7835 12.2845C22.8251 12.4241 22.8251 12.5727 22.7836 12.7124C22.1093 14.9791 20.7409 16.9451 18.9259 18.3652L21.5303 20.9697C21.8232 21.2626 21.8232 21.7374 21.5303 22.0303C21.2374 22.3232 20.7625 22.3232 20.4696 22.0303L2.46964 4.03033C2.17675 3.73744 2.17675 3.26256 2.46964 2.96967ZM17.8561 17.2955C19.4449 16.0998 20.6558 14.4302 21.2795 12.4986C20.0136 8.58178 16.3366 5.75 11.9999 5.75C10.3517 5.75 8.8004 6.15845 7.44018 6.87955L9.93201 9.37138C10.5247 8.979 11.236 8.75 12 8.75C14.071 8.75 15.75 10.4289 15.75 12.5C15.75 13.264 15.521 13.9753 15.1286 14.568L17.8561 17.2955ZM14.0308 13.4702C14.1714 13.1765 14.25 12.8476 14.25 12.5C14.25 11.2574 13.2426 10.25 12 10.25C11.6523 10.25 11.3235 10.3285 11.0298 10.4691L14.0308 13.4702ZM4.46428 8.14996C4.78052 8.41748 4.82002 8.89071 4.55251 9.20695C3.74205 10.165 3.11358 11.2809 2.71955 12.5014C3.98537 16.4182 7.66246 19.25 11.9991 19.25C12.922 19.25 13.8137 19.122 14.6581 18.8832C15.0567 18.7705 15.4712 19.0022 15.5839 19.4008C15.6966 19.7994 15.4649 20.2139 15.0663 20.3266C14.0904 20.6026 13.0613 20.75 11.9991 20.75C6.90226 20.75 2.59889 17.3612 1.21552 12.7155C1.17395 12.5759 1.17393 12.4273 1.21545 12.2877C1.66367 10.7808 2.41867 9.4069 3.40729 8.23819C3.67481 7.92195 4.14804 7.88245 4.46428 8.14996Z"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export default EyeSlashIcon;
